export const validateTextFieldValue = (value: string) => {
  return value.trimStart().replace(/\s\s+/g, ' ')
}
